module.exports = __webpack_public_path__ + "static_pc/img/dl.afc60b66.png";